/* eslint-disable react/prop-types */
import React, { useState, useEffect, memo } from "react";
import { Card, Col, Dropdown, Menu } from "antd";
import { LoadingOutlined, FlagTwoTone, PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import AthenaOperations from "../../../aws/gql/AthenaOperations";
import RawHtml from "../../../util/RawHtml";
import ReportQuestion from "../ReportQuestions";
import {
  NotificationManager
} from "react-notifications";
import IntlMessages from "../../../util/IntlMessages";
const difficyltyEnum = {
  "Easy":{title:"Easy", color:"#4CAF50"},
  "Medium":{title:"Medium", color:"#ff9e00"},
  "Hard":{title:"Hard", color:"#e63946"}
}
const toProperCase = str=> str[0].toUpperCase().concat(str.slice(1).toLowerCase())
const H5PQuestion = memo(({
  question = null,
  question_guid,
  fetchQuestion = false,
  bodyStyle = {},
  cardStyle = {},
  showReportQuestion = true,
  highlightAnswer = true,
  // this shall take following format
  //[{icon,title,handler}]
  contextMenus = []
  
}) => {
  const [loadingQuestion, setLoadingQuestion] = useState(false);
  const [questionError, setQuestionError] = useState("");
  const [questionJson, setQuestionJson] = useState(null);
  const [questionMeta, setQuestionMeta] = useState({});
  const [showReportModal, setShowReportModal] = useState(false);
  const [isUserAuthored,setIsUserAuthored] = useState(false);
  const fetchQuestionJSON = async (questionGuid) => {
    setLoadingQuestion(true);
    try {
      const question_content_json = await AthenaOperations.GetQuestionJson(
        questionGuid
      );
      // console.log(question_content_json)
      const {content_type,content,meta} = question_content_json;
      if(content_type ==='ugc_mcq') setIsUserAuthored(true);
      const h5p_json_content = JSON.parse(
        content.h5p_json
      );
      setQuestionJson(h5p_json_content);
      setQuestionMeta(meta)
      setLoadingQuestion(false);
    } catch (error) {
      setQuestionJson(null);
      setLoadingQuestion(false);
      setQuestionError(error.message);
    }
  };

  const renderOptions = () => {
    const { answers, content_id } = questionJson;
    return (
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {answers.map((option, index) => {
          const { text, correct } = option;
          return (
            <div
              key={`${content_id}_${index}`}
              style={{ display: "contents" }}
            >
              <RawHtml
                html={text}
                containerStyle={{
                  display: "flex",
                  justifyContent: "center",
                  border: "1px solid #a2a2a2 ",
                  borderRadius: "5px",
                  minWidth: "100px",
                  margin: 5,
                  padding: 5,
                  background: highlightAnswer?correct ? "#0cf33366" : "#FFF":"#FFF",
                }}
              />
            </div>
          );
        })}
      </div>
    );
  };
  useEffect(() => {
    if (!question && !question_guid) {
      setQuestionError("Invalid Question");
      setLoadingQuestion(false);
    }
    if (!question || fetchQuestion) {
      // fetch the question here
      fetchQuestionJSON(question_guid);
    }
  }, [fetchQuestion, question, question_guid]);

  const renderDifficultyTag = ()=>{
    const {difficulty_level} = questionMeta;
    const difficulty = difficyltyEnum[difficulty_level];
    // console.log(questionMeta);
    // console.log(difficulty);
    if (!difficulty) return null;
    return (<div style={{...styles.centerColumnFlex, background:difficulty.color, ...styles.difficultyTag}}>{difficulty.title}</div>);
  }
  const renderBloomsTag = ()=>{
    const {blooms} = questionMeta;
    if (!blooms) return null;
    return (<div style={{...styles.centerColumnFlex, background:"#62b6cb", ...styles.bloomsTag}}>{toProperCase(blooms)}</div>);
  }
  const getContextOverlay = ()=>{
    let menus = contextMenus.map((menu,menuIndex)=>(
      <Menu.Item key={`${menuIndex}`} icon={menu.icon} onClick={()=>{
        menu.handler && menu.handler(question_guid)
      }}>
        {menu.title}
      </Menu.Item>))
      menus.push(
        (
          <Menu.Item key={contextMenus.length} icon={ <FlagTwoTone
                          style={{ fontSize: "16px" }}
                          twoToneColor="#f00"
                          title="report"
                        ></FlagTwoTone>} onClick={() => setShowReportModal(true)}>
              Report question
            </Menu.Item>
        )
      )
    return (<Menu onClick={()=>{}} >{menus}</Menu>)
  }
  const renderIsAuthoredTag = ()=>{
    if(!isUserAuthored) return null
    return (<div style={{...styles.centerColumnFlex, background:"rgb(203 117 98)", ...styles.bloomsTag}}><span>User content</span></div>);
  }
  return (
    <Card
      bordered={false}
      bodyStyle={{ marginBottom:"0px", ...bodyStyle }}
      style={{ ...cardStyle }}
    >
      {loadingQuestion && (
        <Col flex>
          <LoadingOutlined />
        </Col>
      )}
      {questionError && <h2>{questionError}</h2>}
      {!loadingQuestion && !questionError && questionJson && (
        <>
          {showReportModal && (
            <ReportQuestion
              showReportModal={showReportModal}
              question_id={question_guid || question.id}
              parentStateHook={setShowReportModal}
              onSelection={() => {
                NotificationManager.info(
                  <IntlMessages id="classroom.questions.reportedQuestion" />
                );
              }}
            />
          )}
          {true && (
            <div
              style={{ position: "absolute", top: 2, right: 2 }}
              className="q_opt_container"
            >
              <Dropdown.Button style={{border:"none"}} onClick={()=>{}} overlay={getContextOverlay}>
              </Dropdown.Button>
            </div>
          )}
          <Col>
            <RawHtml html={questionJson.question} />
            {renderOptions()}
          </Col>
        </>
      )}
      {/* <div style={{ zIndex: 100000 }}>
        <NotificationContainer />
      </div> */}
      <div style={styles.tagContainer}>
        {renderDifficultyTag()}
        {renderBloomsTag()}
        {renderIsAuthoredTag()}
      </div>
    </Card>
  );
});
const styles = {
  tagContainer:{ display:"flex", position: "absolute", top: "2px", left: "25px",color: "#FFF", padding: "0px", margin: "0px", position: "absolute", top: "2px", left: "25px", borderRadius: "5px", fontSize: "8px",fontWeight:"normal" },
  difficultyTag: { color: "#FFF", margin: "2px 2px", padding: "2px 6px", borderRadius: "5px", fontSize: "8px",fontWeight:"normal" },
  bloomsTag: { color: "#FFF",  margin: "2px 2px", padding: "2px 6px",borderRadius: "5px", fontSize: "8px",fontWeight:"normal" },
  seperatorRight:{borderRightWidth:"4px",borderRightColor:"rgb(165 165 165 / 25%)",borderRightStyle:"solid", padding:"5px"},
  rowFlex:{display:"flex", flexDirection:"row"},
  centerColumnFlex:{display:"flex", flexDirection:"column",justifyContent:"center",alignItems: "center", padding: "5px"}
}
export default H5PQuestion;
